import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import banner from './Images/banner.png';
import logo from './Images/logo.png';
import about from './Images/about.png';
import service from './Images/service.png';
import counter from './Images/counter.png';
import team from './Images/teammembers.png';
import quality from './Images/price.png';
import features from './Images/calltoaction.png';
import pri from './Images/price.png';
import footerad from './Images/contact.png';
import footersocial from './Images/social-media.png';
import copyright from './Images/copyright.png';
import timeline from './Images/timeline.png';
import testimonial from './Images/testimonial.png';
import paypalss from './Images/paypal.png';
import mail from './Images/email.png';
import video from './Images/video-tutorials.png';

import "./Setting.css";
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const Setting = () => {
    const [paypal, setPaypal] = useState([]);

    useEffect(() => {
        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/paypal-email`)
            .then((res) => res.json())
            .then((info) => setPaypal(info));
    }, []);

    return (
        <>
         <HeaderBottom></HeaderBottom>
            <div className='setting-menu mb-5'>
                <div className="container text-center mb-5">
                    <div className="row justify-content-center mt-5 mb-5">
                        {/* Static Settings Links */}
                        
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-banner'> 
                                    <img src={banner} alt="Banner" />
                                    <h6>Banner Setting</h6>
                                </Link>
                            </div>
                        
                      
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/add-logo'> 
                                    <img src={logo} alt="Logo" /> 
                                    <h6>Logo Setting</h6> 
                                </Link>
                            </div>
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-counter'> 
                                    <img src={timeline} alt="Logo" /> 
                                    <h6>Counter Seting</h6> 
                                </Link>
                            </div>
                   
                       
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-about'>  
                                    <img src={about} alt="About" /> 
                                    <h6>About Setting</h6> 
                                </Link>
                            </div>
                    
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-service'> 
                                    <img src={service} alt="Service" /> 
                                    <h6>Service Setting</h6> 
                                </Link>
                            </div>
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-feature'> 
                                    <img src={service} alt="Service" /> 
                                    <h6>Feature Setting</h6> 
                                </Link>
                            </div>
                     
                       
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/add-pricing'>  
                                    <img src={quality} alt="Pricing" /> 
                                    <h6>Pricing Setting</h6> 
                                </Link>
                            </div>
                    
                    
                        
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-testimonial'>  
                                    <img src={testimonial} alt="Testimonial" />
                                    <h6>Testimonials</h6> 
                                </Link>
                            </div>
                          

                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/add-address-footer'> 
                                    <img src={footerad} alt="Footer Address" /> 
                                    <h6>Footer Address Setting</h6>
                                </Link>
                            </div>
                     
                     
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/add-social-footer'> 
                                    <img src={footersocial} alt="Footer Social" /> 
                                    <h6>Footer About Setting</h6> 
                                </Link>
                            </div>
                   
                
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/add-copyright'> 
                                    <img src={copyright} alt="Copyright" /> 
                                    <h6>Footer Copy Right Setting</h6> 
                                </Link>
                            </div>
                
                       
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/add-user'> 
                                    <img src={mail} alt="Admin User" /> 
                                    <h6>Admin User Setting</h6> 
                                </Link>
                            </div>
                    

                        {/* Dynamic Paypal Settings Links */}
                        {paypal.map(e => (
                           
                                <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10' key={e._id}>
                                    <Link to={`/paypal-email/${e._id}`}>
                                        <div>
                                            <img src={paypalss} alt="Payment" /> 
                                            <h6>Payment Setting</h6>
                                        </div>
                                    </Link>
                                </div>
                       
                        ))}
                    </div>
                </div>
            </div>
            
        </>
    );
};

export default Setting;
